export const InsertNodeOnEnter = ({ type, onTypes }) => ({
  onKeyDown(event, editor, next) {
    if (event.which !== 13) return next();
    if (editor.value.blocks.some(block => onTypes.includes(block.type))) {
      return editor.insertBlock(type);
    }
    return next();
  },
});
